import '../central/central.css';
import '../giro/giro.css';

/**
 * A subnav de "Visão geral" (telas 11 e 12): Dashboard · Gráficos · Insights numa barra de 40px,
 * não três itens gigantes na sidebar. A Home (tela 05) continua existindo em "Visão geral".
 */

const ABAS: readonly { rota: string; rotulo: string }[] = [
  { rota: 'dashboard', rotulo: 'Dashboard' },
  { rota: 'graficos', rotulo: 'Gráficos' },
  { rota: 'insights', rotulo: 'Insights' },
];

export function SubnavDoPainel({
  atual,
  insights,
  direita,
}: {
  atual: 'dashboard' | 'graficos' | 'insights';
  insights?: number | undefined;
  direita?: React.ReactNode;
}) {
  return (
    <nav className="cv-subnav" aria-label="Visão geral">
      {ABAS.map((a) => (
        <span key={a.rota} className="cv-subnav-item">
          <a
            href={`#/${a.rota}`}
            className={atual === a.rota ? 'cv-sel' : ''}
            aria-current={atual === a.rota ? 'page' : undefined}
          >
            {a.rotulo}
            {a.rota === 'insights' && insights !== undefined && insights > 0 && (
              <span className="gr-contador">{insights}</span>
            )}
          </a>
        </span>
      ))}
      <span style={{ flex: 1 }} />
      {direita && <span className="cv-subnav-direita">{direita}</span>}
    </nav>
  );
}
